import MuiButton from '@mui/material/Button';
import colors from '../../../assets/colors';
import { styled } from '@mui/system';

const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'index',
})(({ selected, index }) => ({
  ...(selected === index && {
    '&.MuiButton-contained': {
      backgroundColor: colors.yellow,
      '&:hover': {
        opacity: 0.8,
        backgroundColor: colors.yellow,
      },
    },
  }),
}));

function GroupButton(props) {
  const { children, classes: cls, ...rest } = props;

  return (
    <StyledButton
      classes={{
        ...cls,
      }}
      {...rest}
    >
      {children}
    </StyledButton>
  );
}

export default GroupButton;
